import { render, staticRenderFns } from "./ArchiveInfo.vue?vue&type=template&id=1fae5db9&scoped=true"
import script from "./ArchiveInfo.vue?vue&type=script&lang=js"
export * from "./ArchiveInfo.vue?vue&type=script&lang=js"
import style0 from "./ArchiveInfo.vue?vue&type=style&index=0&id=1fae5db9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fae5db9",
  null
  
)

export default component.exports